import React from 'react';
import { ShieldCheckIcon, BadgeCheckIcon, DownloadIcon, LockIcon, HeadphonesIcon } from 'lucide-react';
export function TrustBar() {
  const items = [{
    icon: ShieldCheckIcon,
    text: 'Pago Seguro'
  }, {
    icon: BadgeCheckIcon,
    text: 'Garantía'
  }, {
    icon: DownloadIcon,
    text: 'Descarga Inmediata'
  }, {
    icon: LockIcon,
    text: 'Protección de Datos'
  }, {
    icon: HeadphonesIcon,
    text: 'Soporte'
  }];
  return <div className="bg-[#FEF3E2] border-y border-[#E8D5C4] py-6 px-4" data-id="element-207">
      <div className="max-w-6xl mx-auto flex flex-wrap justify-center gap-6 md:gap-12" data-id="element-208">
        {items.map((item, index) => <div key={index} className="flex items-center gap-2 text-[#6B5344]" data-id="element-209">
            <item.icon className="w-5 h-5 text-[#D4850A]" data-id="element-210" />
            <span className="text-sm md:text-base font-medium" data-id="element-211">
              {item.text}
            </span>
          </div>)}
      </div>
    </div>;
}